import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  isNonEmptyString,
  createCustomPropType,
  isNumeric,
} from '../../../../js/app/react/validators';
import AdvForm from '../../../CommonComponents/AdvForm';
import Validation from '../../Validation/ValidationContainer';
import ButtonWithLoading from '../../ButtonWithLoading/ButtonWithLoadingContainer';
import { BACKEND_KEY } from '../PersonalInfoWorkflowConstants';
import Input, { LEFT } from '../../Input/InputView';
import InputAge from '../../InputAge/InputAgeView';
import BackMobileNavigation from '../../BackMobileNavigation/BackMobileNavigationView';

class ChildrenAddEditView extends Component {
  constructor() {
    super();
    this.state = {
      name: '',
      age: '',
    };

    this.onNameChanged = this.onNameChanged.bind(this);
    this.onAgeChanged = this.onAgeChanged.bind(this);
  }
  UNSAFE_componentWillMount() {
    const { child } = this.props;
    this.setState({
      name: child.FirstName,
      age: child.Age,
    });
  }

  onNameChanged(event) {
    this.setState({
      name: event.target.value,
    });
  }

  onAgeChanged(event) {
    this.setState({
      age: event.target.value,
    });
  }

  render() {
    const { workflowId, clientId, children, onSave, onCancel, index, isEdit } = this.props;
    return (
      <AdvForm className="AccountAddEditView with-mobile-top-padding">
        <BackMobileNavigation
          label="Add Child"
          onBack={onCancel(workflowId, clientId, isEdit, children)}
        />
        <Validation workflowId={workflowId} validationId={`${BACKEND_KEY}.ChildrenAddEdit`} />
        <h2 className="h2">Please add their name and age.</h2>
        <ul className="form-input-list">
          <li className="form-input">
            <Input
              maxLength="256"
              placeholder="Name"
              id="child-name"
              alignment={LEFT}
              className="nickname"
              value={this.state.name}
              onChange={this.onNameChanged}
            />
          </li>
          <li className="form-input">
            <InputAge
              maxLength={3}
              isLeftAligned
              placeholder="Age"
              className="add-edit"
              value={this.state.age}
              id="child-age"
              onChange={this.onAgeChanged}
            />
          </li>
        </ul>
        <div className="footer">
          <button
            type="button"
            className="adv-workflow-navigation-cancel-button"
            onClick={onCancel(workflowId, clientId, isEdit, children)}
          >
            Cancel
          </button>
          <ButtonWithLoading
            workflowId={workflowId}
            type="button"
            className="adv-workflow-navigation-next-save-button"
            onClick={onSave(children, workflowId, this.state, index, clientId)}
          >
            Save Child
          </ButtonWithLoading>
        </div>
      </AdvForm>
    );
  }
}

ChildrenAddEditView.defaultProps = {};

ChildrenAddEditView.propTypes = {
  isEdit: PropTypes.bool.isRequired,
  workflowId: createCustomPropType(isNonEmptyString).isRequired,
  clientId: createCustomPropType(isNumeric).isRequired,
  onSave: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  children: PropTypes.arrayOf(
    PropTypes.shape({
      FirstName: createCustomPropType(isNonEmptyString).isRequired,
      Age: createCustomPropType(isNumeric).isRequired,
    }),
  ).isRequired,
  child: PropTypes.shape({}).isRequired,
  index: PropTypes.number.isRequired,
};

export default ChildrenAddEditView;
